<template>
  <div @click="onClick" class="power-banner">
    <div class="power-image">
        <img
          src="../assets/images/power_white.png"
          alt="Tinaba"
        />
      </div>
      <div class="power-text f-r">
        Power, più lo usi meno spendi!<br>
        Attivalo subito!
      </div>
  </div>
</template>

<script>
import UtilityService from "@/services/UtilityService";

export default {
  name: "PowerBanner",

  methods: {
    onClick() {
      UtilityService.goToFeePot();
    }
  },
};
</script>

<style scoped lang="less">
.power-banner{
  display: flex;
  align-items: center;
  background-color: rgba(255,94,0,0.1);
  border-radius: 8px;
  padding: 10px 20px;

  img {
    width: 60px;
    margin-right: 20px;
  }
}
</style>
